import React, { useState, useEffect } from "react";
import { Card, Button, Tag, Row, Col, Typography } from "antd";
import './main.css';

const { Title, Text } = Typography;

const LOCAL_STORAGE_KEY = "whats_new_seen_date";

const whatsNewFeatures = [
  {
    image: "https://public-assets.instantdm.com/app.instantdm.com-assest/Manage+Multi+account+in+single+plan.png",
    title: "Multi Account on Single plan",
    description: "You can now manage multiple accounts on a single plan. No need to purchase separate plans for each account.",
    buttonText: "Upgrade Now",
    buttonLink: null,
    tag: { color: "#10B981", text: "New" },
    release_date: "28/01/2026"
  },
  {
    image: "https://public-assets.instantdm.com/app.instantdm.com-assest/automate-brand-collab.png",
    title: "Automate Collab posts",
    description: "Automate your collaboration posts and track leads directly from your dashboard.",
    buttonText: "Try Now",
    buttonLink: '/ig',
    tag: { color: "#3B82F6", text: "New" },
    release_date: "28/01/2026"
  },
];

const WhatsNew = ({ setShowPlanModal }) => {
  // Currency detection based on timezone
  const user_tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const isINR = user_tz === "Asia/Kolkata" || user_tz === "Asia/Calcutta";

  // Filter features based on 4-day visibility logic
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const visibleFeatures = whatsNewFeatures.filter(feature => {
    if (!feature.release_date) return false;

    const parts = feature.release_date.split('/');
    const releaseDate = new Date(parts[2], parts[1] - 1, parts[0]);
    // releaseDate.setHours(0,0,0,0); // releaseDate is roughly 00:00 already

    const diffTime = today - releaseDate;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    // Show if diffDays is between 0 and 4 inclusive
    return diffDays >= 0 && diffDays <= 4;
  });

  if (visibleFeatures.length === 0) {
    return null;
  }

  return (
    <div style={{ maxWidth: '900px', margin: '0 auto 40px' }}>
      <div style={{ marginBottom: '20px', textAlign: 'center' }}>
        <Title level={3} style={{ color: '#1a1a2e', fontSize: '20px', fontWeight: 600, marginBottom: '6px' }}>
          🚀 What's New in InstantDM
        </Title>
        <Text style={{ color: '#888', fontSize: '14px' }}>
          Check out the latest features and updates
        </Text>
      </div>

      <div className="whats-new-grid">
        {visibleFeatures.map((feature, idx) => (
          <div
            key={idx}
            style={{
              background: '#ffffff',
              borderRadius: '16px',
              overflow: 'hidden',
              border: '1px solid rgba(0, 0, 0, 0.06)',
              boxShadow: '0 4px 16px rgba(0, 0, 0, 0.04)',
              display: 'flex',
              flexDirection: 'column',
              transition: 'all 0.3s ease',
              cursor: 'pointer'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-6px)';
              e.currentTarget.style.boxShadow = '0 16px 32px rgba(0, 0, 0, 0.1)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 4px 16px rgba(0, 0, 0, 0.04)';
            }}
          >
            {/* Image Area */}
            <div style={{
              width: '100%',
              aspectRatio: '16/10',
              background: '#f3f4f6',
              position: 'relative',
              overflow: 'hidden'
            }}>
              <img
                src={feature.image}
                alt={feature.title}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  position: 'relative',
                  zIndex: 1
                }}
                onError={(e) => { e.target.style.display = 'none' }} // Digraceful falback
              />
              {/* Fallback pattern if image fails or while loading */}
              <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                background: 'linear-gradient(45deg, #f3f4f6 25%, #e5e7eb 25%, #e5e7eb 50%, #f3f4f6 50%, #f3f4f6 75%, #e5e7eb 75%, #e5e7eb 100%)',
                backgroundSize: '20px 20px',
                opacity: 0.5,
                zIndex: 0
              }}></div>

              <div style={{
                position: 'absolute',
                top: '12px',
                right: '12px',
                zIndex: 2
              }}>
                <Tag color={feature.tag.color} style={{
                  border: 'none',
                  borderRadius: '4px',
                  fontWeight: 600,
                  boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                }}>
                  {feature.tag.text}
                </Tag>
              </div>
            </div>

            {/* Content Area */}
            <div style={{ padding: '20px', flex: 1, display: 'flex', flexDirection: 'column' }}>
              <h4 style={{
                margin: '0 0 8px 0',
                fontSize: '16px',
                fontWeight: 600,
                color: '#1a1a2e',
                lineHeight: 1.4
              }}>
                {feature.title}
              </h4>
              <p style={{
                margin: '0 0 16px 0',
                fontSize: '13px',
                color: '#666',
                lineHeight: 1.5,
                flex: 1
              }}>
                {feature.description}
              </p>

              {feature.buttonLink !== undefined && (
                <Button
                  type="default"
                  block
                  style={{
                    borderRadius: '8px',
                    fontWeight: 500,
                    fontSize: '13px',
                    height: '38px'
                  }}
                  onClick={() => {
                    if (feature.title === "Multi Account on Single plan" && setShowPlanModal) {
                      setShowPlanModal(true);
                    } else if (feature.buttonLink) {
                      window.location.href = feature.buttonLink;
                    }
                  }}
                >
                  {feature.title === "Multi Account on Single plan"
                    ? `See Pricing`
                    : feature.buttonText}
                </Button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default WhatsNew;